<template>
  <div class="project">
    <Progress
      size="mini"
      :active-index="1"
      :step-list="stepList"
    />
    <!-- <div class="titleBar">
      <div class="title">
        <span>{{ insureProject.name }}</span>
        <small>({{ dateFormat(insureProject.showTime) }})</small>
      </div>
      <div>
        <a-button @click="goBack">
          {{ back }} 返回
        </a-button>
      </div>
    </div> -->
    <div class="search">
      <img
        src="@/assets/image/icon-ss.png"
        alt=""
      >
      <a-input
        v-model="query.keywords"
        placeholder="输入关键词搜索"
      />
      <div class="phase">
        <span>标段阶段</span>
        <a-select
          v-model="query.projectStatus"
        >
          <a-select-option value="4">
            全部
          </a-select-option>
          <a-select-option value="0">
            正常
          </a-select-option>
          <a-select-option value="1">
            暂停
          </a-select-option>
          <a-select-option value="2">
            终止
          </a-select-option>
          <a-select-option value="3">
            流标
          </a-select-option>
        </a-select>
      </div>
      <a-button
        type="primary"
        @click="search"
      >
        查询
      </a-button>
      <a-button
        type="primary"
        @click="reset"
      >
        重置
      </a-button>
      <a-button
        class="back"
        @click="goBack"
      >
        {{ back }} 返回
      </a-button>
    </div>
    <!-- 表格 -->
    <a-spin :spinning="loading">
      <div class="table">
        <!-- v-for -->

        <div
          class="forTable"
          v-for="(item,index) in data"
          :key="index"
        >
          <!-- <div class="top">
            <span class="top1">{{ item.sectionName }}</span>
            <p class="top3">
              {{ item.sectionCode }}
            </p>
          </div> -->
          <div class="bottom">
            <div class="div1">
              <p>项目名称</p>
              <p>{{ item.projectName }}</p>
            </div>
            <div class="div2">
              <p>标段名称</p>
              <p>{{ item.sectionName }}</p>
            </div>
            <div class="div3">
              <p>标段编号</p>
              <p>{{ item.sectionCode }}</p>
            </div>
            <div class="div4">
              <p>项目开标截止时间</p>
              <p>{{ dateFormat(item.bidOpenTime) }}</p>
            </div>
            <div class="div5">
              <p>保额</p>
              <p>￥{{ item.marginAmount }}</p>
            </div>
            <div class="div6">
              <p>标段阶段</p>
              <p>{{ status(item.projectStatus) }}</p>
            </div>
            <div>
              <!-- 申请按钮 -->
              <a-button
                type="primary"
                v-if="item.applyState === '1'"
                @click="apply(item.sectionId)"
              >
                申请
              </a-button>
              <a-button
                type="primary"
                v-else
                class="applyed"
              >
                已申请
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import Progress from '@/components/Progress';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { sectionList } from '@/api/insure/project.js';
import { dateFormat } from '@/utils/format.js';
export default {
  name: 'ProView',
  components: {
    Progress,
  },
  data() {
    return {
      activeIndex: 0,
      dateFormat,
      back: '<',
      locale,
      loading: false,
      abnormal: '', // 标段异常
      headers: {
        authorization: 'authorization-text',
      }, // 请求头
      visible: false, // 弹窗显示
      confirmLoading: false, // 确定加载
      insureProject: {},
      query: { projectStatus: '4' },
      data: [],
      columns: [
        {
          title: '项目',
          dataIndex: 'name',
          key: 'name',
          slots: { title: '项目' },
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '标段数',
          dataIndex: 'paragraph',
          key: 'paragraph',
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      options: [
        { label: '标段延期', value: '0' },
        { label: '标段流标', value: '1' },
        { label: '标段终止', value: '2' },
      ],
      stepList: [{
        name: '选择项目',
        flag: 0,
      }, {
        name: '确认项目',
        flag: 1,
      }, {
        name: '确认投保',
        flag: 2,
      }, {
        name: '投保审核',
        flag: 3,
      }, {
        name: '保费支付',
        flag: 4,
      }, {
        name: '保函发放',
        flag: 5,
      }],
      projectStatus: [{
        label: '正常',
        value: '0',
      }, {
        label: '暂停',
        value: '1',
      }, {
        label: '终止',
        value: '2',
      }, {
        label: '流标',
        value: '3',
      }],
    };
  },
  mounted() {
    this.insureProject = JSON.parse(sessionStorage.getItem('insureProject'));
    if (typeof this.insureProject === 'string') {
      this.fetch({ projectId: this.insureProject });
    } else {
      this.fetch({ projectId: this.insureProject.projectId });
    }
    if (this.$route.query.count) {
      this.activeIndex = Number(this.$route.query.count);
    }
  },
  methods: {
    status(data) {
      const statu = this.projectStatus.filter(item => {
        // indexOf获取value在数组中出现的首个位置
        return item.value === data;
      });
      return statu[0].label;
    },
    apply(id) {
      this.$router.push({ name: 'Project', query: { count: 2 } });
      sessionStorage.setItem('projectSectionId', JSON.stringify(id));
    },
    search() {
      if (this.query.projectStatus === '4') {
        this.fetch({ projectId: this.insureProject.projectId, keywords: this.query.keywords });
      } else {
        this.fetch({ projectId: this.insureProject.projectId, keywords: this.query.keywords, projectStatus: this.query.projectStatus });
      }
    },
    reset() {
      this.query.keywords = null;
      this.query.projectStatus = '4';
      this.search();
    },
    fetch(params = {}) {
      this.loading = true;
      sectionList({ ...params }).then(({ data }) => {
        this.loading = false;
        this.data = data.data;
      });
    },
    // // 弹窗文件上传
    // handleChange(info) {
    //   if (info.file.status !== 'uploading') {
    //   }
    //   if (info.file.status === 'done') {
    //     this.$message.success(`${info.file.name} file uploaded successfully`);
    //   } else if (info.file.status === 'error') {
    //     this.$message.error(`${info.file.name} file upload failed.`);
    //   }
    // },
    // // 弹窗显示
    // showModal() {
    //   this.visible = true;
    // },
    // // 弹窗确定
    // handleOk(e) {
    //   this.ModalText = 'The modal will be closed after two seconds';
    //   this.confirmLoading = true;
    //   setTimeout(() => {
    //     this.visible = false;
    //     this.confirmLoading = false;
    //   }, 2000);
    // },
    // // 弹窗取消
    // handleCancel(e) {
    //   this.visible = false;
    // },
    // 返回
    goBack() {
      this.$router.push({ name: 'Project' });
    },
  },
};
</script>
<style lang="less" scoped>
.project {
  min-height: 666px;
  .titleBar {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    .title {
      span {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #000000;
      }
      small {
        font-size: 16px;
        font-family: Microsoft YaHei;
      }
    }
    button {
      height: 30px;
      background: #FFFFFF;
      border: 1px solid #E1E8EF;
      border-radius: 3px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #AAAAAA;
    }
  }
  .search {
    display: flex;
    margin: 30px 0 20px 0;
    position: relative;
    img {
      width: 14px;
      height: 14px;
      position: absolute;
      top: 9px;
      left: 10px;
      z-index: 99;
    }
    /deep/ .ant-input-affix-wrapper {
      width: 300px;
    }
    /deep/ .ant-input {
      width: 300px;
      height: 32px;
      background: #FFFFFF;
      border: 1px solid #E1E8EF;
      border-radius: 3px;
      padding-left: 40px;
    }
    .phase {
      span {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #AAAAAA;
        margin: 0 10px 0 30px;
      }
      /deep/ .ant-select-selection {
        width: 120px;
        height: 32px;
        background: #FFFFFF;
        border: 1px solid #E1E8EF;
        border-radius: 3px;
      }
    }
    button {
      background-color: #007CE2;
      margin-left: 30px;
    }
    .back {
      position: absolute;
      top: 1px;
      right: 0;
      height: 30px;
      background: #FFFFFF;
      border: 1px solid #E1E8EF;
      border-radius: 3px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 600;
      color: #999;
    }
  }
  .tabProject {
    display: flex;
  }
  .table {
    .forTable {
      margin-bottom: 20px;
      border: 1px solid #EBF2F7;
    }
    .top {
      width: 920px;
      height: 80px;
      background: #F7FAFF;
      padding: 20px 40px 17px 30px;
      position: relative;
      font-family: Microsoft YaHei;
      .top1 {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
      }
      .top2 {
        font-size: 14px;
        font-weight: 400;
        color: #AAAAAA;
        position: absolute;
        right: 41px;
      }
      .top3 {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        margin-top: 5px;
      }
    }
    .bottom {
      display: flex;
      width: 920px;
      background: #FFFFFF;
      padding: 25px 40px 3px 30px;
      p {
        margin: 0;
      }
      .div1 {
        width: 180px;
      }
      .div2 {
        width: 120px;
      }
      .div3 {
        width: 80px;
      }
      .div4 {
        width: 145px;
      }
      .div5 {
        width: 75px;
      }
      .div6 {
        width: 65px;
      }
      div {
        margin: 9px;
        p {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          &:nth-child(1) {
            color: #AAAAAA;
          }
          &:nth-child(2) {
            color: #333333;
          }
        }
        a {
          margin-right: 10px;
        }
        button {
          width: 72px;
        }
        .applyed {
          background: #B2D7F6;
          border: #B2D7F6;
        }
      }
    }
  }
}
</style>
